export const pathnameDict = {
  '/': 'Home',
  '/profile/modify': 'Edit subscription'
}
